import { Link } from 'react-router-dom'
import SEOHead from '../components/SEOHead'
import GallerySection from '../components/GallerySection'
import ContactForm from '../components/ContactForm'
import YouTubeFacade from '../components/YouTubeFacade'
import { useCmsPage } from '../hooks/useCmsPage'

export default function BryllupPage() {
  const { page } = useCmsPage('bryllup')

  const title = page?.meta_title || 'DJ til bryllup — Casper DJ'
  const description =
    page?.meta_description ||
    'Søger du en DJ til dit bryllup? Så skal du være meget velkommen til at kontakte CasperDJ. Jeg sørger for et varieret musikudvalg, der kan tilpasses forskellige kulturer og generationer., Søger du en DJ til dit bryllup? Så skal du være meget velkommen til at kontakte CasperDJ. Jeg sørger for et varieret musikudvalg, der kan tilpasses forskellige kulturer og generationer.'

  const extractVideoId = (url) => {
    if (!url) return 'VBybl7fL1Do'
    if (url.includes('embed/')) {
      return url.split('embed/')[1]?.split('?')[0]?.split('&')[0] || 'VBybl7fL1Do'
    }
    if (url.includes('v=')) {
      return url.split('v=')[1]?.split('&')[0] || 'VBybl7fL1Do'
    }
    if (url.includes('youtu.be/')) {
      return url.split('youtu.be/')[1]?.split('?')[0]?.split('&')[0] || 'VBybl7fL1Do'
    }
    return url.trim() || 'VBybl7fL1Do'
  }

  const videoId = extractVideoId(page?.video_url)

  return (
    <div className="bg-neutral-950 text-white min-h-screen">
      <SEOHead title={title} description={description} />

      {/* Hero */}
      <section className="pt-32 pb-16 md:pt-48 md:pb-24 border-b border-neutral-900 bg-neutral-900/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-10">
            <div className="space-y-6">
              <span className="text-xs font-semibold tracking-widest text-gold-400 uppercase">
                DJ til dit bryllup
              </span>
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-white leading-tight">
                DJ til dit bryllup:
              </h1>
              <p className="text-base sm:text-lg text-neutral-300 leading-relaxed">
                Et bryllup er én af livets største begivenheder, og det kan ikke gøres om. Uanset om planen er en intim lille fejring eller et overdådigt slotsbryllup er det rette musikvalg og en professionel eksekvering afgørende for stemningen. Det ansvar tager vi stolt på os hos{' '}
                <Link to="/" className="text-gold-400 font-semibold hover:underline">
                  CasperDJ
                </Link>
                , som dj til brylluppet.
              </p>

              <div className="pt-2">
                <h3 className="text-lg font-bold text-white mb-2">
                  Skræddersyet musik til bryllupsfesten
                </h3>
                <p className="text-sm sm:text-base text-neutral-300 leading-relaxed">
                  Det kræver meget tid og energi at planlægge drømmebrylluppet. Fokusér derfor på de andre praktiske opgaver, og lad os hjælpe med at gøre jeres store dag til en vellykket fest. Et hvilket som helst setup er muligt – det er jeres dag og jer, der bestemmer.
                </p>
                <p className="text-sm sm:text-base text-neutral-300 leading-relaxed mt-3">
                  Diskoteket er opstillet og klar før festen starter, så gæsterne kan gå uforstyrret til bords. Vi tilbyder dæmpet musik under middagen i form af eksempelvis harpenist eller saxofonist, og herefter er vi leveringsdygtige i dansemusik uanset genre. Musikudvalget tilpasses naturligvis jeres ønsker, og festens toastmaster er velkommen til at kontakte os med eventuelle særlige musikønsker.
                </p>
              </div>

              <div className="pt-2 flex flex-wrap gap-4">
                <Link
                  to="/kontakt"
                  className="px-8 py-3.5 bg-gold-400 text-neutral-950 font-bold text-sm uppercase tracking-wider rounded-xl hover:bg-gold-300 transition-colors shadow-lg cursor-pointer"
                >
                  Kontakt mig
                </Link>
                <a
                  href="tel:+4530405006"
                  className="px-6 py-3.5 border border-neutral-800 bg-neutral-900 text-white font-bold text-sm uppercase tracking-wider rounded-xl hover:border-gold-400/50 hover:text-gold-400 transition-colors cursor-pointer flex items-center gap-2 whitespace-nowrap"
                >
                  <i className="fa-solid fa-phone text-gold-400 text-xs" aria-hidden="true" />
                  <span className="whitespace-nowrap">+45 30 40 50 06</span>
                </a>
              </div>
            </div>

            {/* Video facade under text */}
            <div className="pt-4">
              <YouTubeFacade
                videoId={videoId}
                title="CasperDJ til bryllup"
                poster={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
              />
            </div>
          </div>
        </div>
      </section>

      {/* CasperDJ sikrer altid */}
      <section className="py-20 bg-neutral-950 border-b border-neutral-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center mb-14">
            <span className="text-xs font-semibold tracking-widest text-gold-400 uppercase">
              Tryghed på jeres store dag
            </span>
            <h2 className="text-3xl font-extrabold text-white mt-1">
              CasperDJ sikrer altid
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="p-8 rounded-2xl bg-neutral-900/60 border border-neutral-800 space-y-4">
              <div className="w-12 h-12 rounded-xl bg-gold-400/10 border border-gold-400/30 text-gold-400 flex items-center justify-center text-lg">
                <i className="fa-solid fa-shield-check" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-white">
                Professionel afvikling af jeres fest
              </h3>
              <p className="text-sm text-neutral-300 leading-relaxed">
                Med CasperDJ kan I forvente en professionel og problemfri afvikling af jeres fest. Jeg sørger for at koordinere musikken og stemningen på en måde, der passer perfekt til jeres begivenhed, så I kan slappe af og nyde festen uden bekymringer.
              </p>
            </div>

            <div className="p-8 rounded-2xl bg-neutral-900/60 border border-neutral-800 space-y-4">
              <div className="w-12 h-12 rounded-xl bg-gold-400/10 border border-gold-400/30 text-gold-400 flex items-center justify-center text-lg">
                <i className="fa-solid fa-music" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-white">
                Et varieret musikudvalg, der kan tilpasses forskellige kulturer og generationer
              </h3>
              <p className="text-sm text-neutral-300 leading-relaxed">
                Jeg tilbyder et bredt udvalg af musikgenrer og sange, der kan tilpasses forskellige kulturer og generationer. Uanset om I foretrækker klassiske hits, de nyeste trends eller internationale favoritter, sørger jeg for at skabe et lydbillede, der appellerer til alle gæster og holder dansegulvet fyldt hele aftenen.
              </p>
            </div>

            <div className="p-8 rounded-2xl bg-neutral-900/60 border border-neutral-800 space-y-4">
              <div className="w-12 h-12 rounded-xl bg-gold-400/10 border border-gold-400/30 text-gold-400 flex items-center justify-center text-lg">
                <i className="fa-solid fa-clock" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-white">
                Opstilling af diskotek inden gæsternes ankomst og hurtig nedpakning efter festen
              </h3>
              <p className="text-sm text-neutral-300 leading-relaxed">
                For at sikre en gnidningsløs festoplevelse sørger jeg for at opstille diskoteket og lydudstyret op ca. en time før gæsternes ankomst. Efter festen er slut, pakker jeg hurtigt og effektivt alt ned, så I kan fokusere på at sige farvel til jeres gæster og nyde de gode minder fra aftenen uden at bekymre jer om oprydning.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <GallerySection
        gallerySlug="bryllup-billeder"
        title="Billeder fra bryllupper"
        subtitle="Se stemningen fra romantiske fejringer og fyldte dansegulve."
      />

      {/* Wedding Quote Form */}
      <section className="py-20 bg-neutral-950 border-t border-neutral-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ContactForm
            title="Få et uforpligtende bryllupstilbud"
            subtitle="Fortæl mig om jeres ønsker og dato for det store bryllup."
          />
        </div>
      </section>
    </div>
  )
}
